<!-- Floating Chat Button -->
<button
  type="button"
  class="concierge-fab"
  (click)="toggleChat()"
  [attr.aria-expanded]="isOpen"
  aria-label="Open help chat">
  @if (isOpen) {
    <lucide-icon name="x"></lucide-icon>
  } @else {
    <lucide-icon name="message-circle"></lucide-icon>
  }
</button>

<!-- Chat Window -->
@if (isOpen) {
  <div class="concierge-window">
    <!-- Header -->
    <div class="concierge-header">
      <div class="concierge-header-title">
        <lucide-icon name="bot" class="me-2"></lucide-icon>
        <span>{{ 'CONCIERGE.TITLE' | translate }}</span>
      </div>
      <div class="concierge-header-actions">
        <button
          type="button"
          class="btn btn-sm btn-link text-white"
          (click)="clearChat()"
          [title]="'CONCIERGE.CLEAR' | translate">
          <lucide-icon name="refresh-cw"></lucide-icon>
        </button>
        <button
          type="button"
          class="btn btn-sm btn-link text-white"
          (click)="toggleChat()">
          <lucide-icon name="minus"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Messages -->
    <div class="concierge-messages" #messageContainer>
      @if (messages.length === 0) {
        <div class="concierge-welcome">
          <lucide-icon name="lightbulb" class="mb-3"></lucide-icon>
          <p>{{ 'CONCIERGE.WELCOME' | translate }}</p>
          <small class="text-muted">{{ 'CONCIERGE.HINT' | translate }}</small>
        </div>
      }

      @for (message of messages; track message.timestamp) {
        <div class="concierge-message" [class.user]="message.role === 'user'">
          @if (message.role === 'user') {
            <div class="message-content">{{ message.content }}</div>
          } @else {
            @let parsed = getParsedMessage(message);
            <div class="message-content" [innerHTML]="parsed.content"></div>
            @if (parsed.docLinks.length > 0) {
              <div class="message-doc-links">
                @for (link of parsed.docLinks; track link.url) {
                  <button type="button" class="doc-link-btn" (click)="openDocLink(link.url)">
                    <lucide-icon name="file-text" class="doc-icon"></lucide-icon>
                    {{ link.title }}
                    <lucide-icon name="external-link" class="external-link-icon"></lucide-icon>
                  </button>
                }
              </div>
            }
          }
        </div>
      }

      @if (isLoading) {
        <div class="concierge-message">
          <div class="message-content typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      }

      @if (error) {
        <div class="concierge-error">
          <lucide-icon name="circle-alert" class="me-2"></lucide-icon>
          {{ error }}
        </div>
      }
    </div>

    <!-- Input -->
    <div class="concierge-input">
      <textarea
        #inputField
        [(ngModel)]="userInput"
        (keydown)="onKeydown($event)"
        [placeholder]="'CONCIERGE.PLACEHOLDER' | translate"
        [disabled]="isLoading"
        rows="1"
        maxlength="1000">
      </textarea>
      <button
        type="button"
        class="send-button"
        (click)="sendMessage()"
        [disabled]="!userInput.trim() || isLoading">
        <lucide-icon name="send"></lucide-icon>
      </button>
    </div>
  </div>
}
